import { Navigate, Route, Routes } from 'react-router-dom';
import { MissionProvider } from '../context/MissionContext';
import MissionCenter from '../components/missions/MissionCenter';
import MissionRunnerView from '../components/missions/MissionRunnerView';
import MasteryOverview from '../components/missions/MasteryOverview';
import DecksView from '../components/missions/DecksView';
import DeckReviewLauncher from '../components/missions/DeckReviewLauncher';
import ReviewSession from '../components/learn/ReviewSession';
import DialogueSession from '../components/learn/DialogueSession';

/**
 * `/missions/*` — the Mastery Missions area (spec §8.1, §10.3).
 *
 * `MissionProvider` is mounted here rather than in `App.jsx` so the mission
 * list, its filters and the in-flight-attempt plumbing only exist while this
 * area is open, and no other package has to change its provider tree to ship
 * this one.
 *
 * Routes
 *   index                Mission Center
 *   run/:missionId       Mission Runner (five steps)
 *   review/:deckId       opens a spaced-repetition session for a deck …
 *   session/:id          … and hands over to the existing ReviewSession
 *   dialogue/:id         existing Socratic DialogueSession
 *   decks                existing DeckManager + StatsPanel
 *   mastery              levels, calibration, activity over time
 */
export default function MissionsPage() {
  return (
    <MissionProvider>
      <Routes>
        <Route index element={<MissionCenter />} />
        <Route path="run/:missionId" element={<MissionRunnerView />} />
        <Route path="review/:deckId" element={<DeckReviewLauncher />} />
        <Route path="session/:id" element={<ReviewSession />} />
        <Route path="dialogue/:id" element={<DialogueSession />} />
        <Route path="decks" element={<DecksView />} />
        <Route path="mastery" element={<MasteryOverview />} />
        <Route path="*" element={<Navigate to="/missions" replace />} />
      </Routes>
    </MissionProvider>
  );
}
